/* eslint-disable */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { JSONTree } from 'react-json-tree';
import Modal from 'modules/common/components/Modal';

function ViewTransactionLogDetailModal({
  data,
}) {

  const parseNestedObject = (obj) => {
    return _.mapValues(obj, value => {
        if (_.isString(value)) {
            try {
                return JSON.parse(value);
            } catch (error) {
                console.error('Error parsing JSON:', error);
                return value; 
            }
        } else if (_.isObject(value)) {
            return parseNestedObject(value);
        }
        return value;
    });
  }

  return (
    <Modal.Body>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 px-0">
            <h4>Payload</h4>
            <JSONTree data={parseNestedObject(_.get(data, "payload")) || {}} />
          </div>
        </div>
      </div>
    </Modal.Body>
  );
}

ViewTransactionLogDetailModal.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

ViewTransactionLogDetailModal.defaultProps = {
  data: '',
};

export default ViewTransactionLogDetailModal;
